module.exports = __webpack_public_path__ + "static/img/map-bg.95ef0f40.png";